import { usePkwInputStore } from '@/features/Sparten/pkw/useInputStore';
import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import {
  hasGapDeckung,
  hasNoDamage,
  hasOneChild,
  hasSeveralChildren,
  isAlsBetriebsausgabeAnerkannt,
  isCompanyOrWorksInAutomotive,
  isErstbesitzer,
  isFahrerkreisAny,
  isFahrerkreisFix,
  isFahrerkreisNoAgeRestriction,
  isFahrerkreisVNDriver,
  isHaftpflicht,
  isNoAbweichenderHalter,
  isNoJahreskarteOffentlicherPersonenverkehr,
  isNoMinors,
  isNoSaisonkennzeichen,
  isNoSaisonKennzeichen,
  isNotAnAdditionalCar,
  isNoTeilkasko,
  isNotGermanOrIsCompany,
  isNotHaftpflichtFeature,
  isNoVollkasko,
  isNoVorversicherung,
  isNoWohnungseigentum,
  isOnlyHaftpflichtFeature,
  isOnlyVollkaskoFeature,
  isVnVorsteuerabzugsberechtigt,
  temporaryField,
} from '@/features/Sparten/shared/inputDehydration/kfz/conditionalRequestDefinitions';
import { computed } from 'vue';

const isFirma: ConditionalRequestDefinition = {
  if: computed(() => usePkwInputStore().versicherungsnehmer.isFirma),
  drop: [
    'anredeId',
    'geburtsdatum',
    'familienstand',
    'nationalitaet',
    'versicherungsnehmer.berufsstatus',
    'versicherungsnehmer.beruf',
    'versicherungsnehmer.speziellerArbeitgeber',
    'versicherungsnehmer.tarifgruppe',
    'versicherungsnehmer.hasMinderjaehrigeKinder',
    'versicherungsnehmer.minderjaehrigeKinder',
    'versicherungsnehmer.hasFuehrerscheinInEUErworben',
    'versicherungsnehmer.hasAnBegleitetenFahrenTeilgenommen',
    'versicherungsnehmer.hasAnSicherheitstrainingTeilgenommen',
    'versicherungsnehmer.isMitarbeiterAutohersteller',
    'versicherungsnehmer.hasWohnsitzMin5JahreInBrd',
    'versicherungsnehmer.hasPunkteInFlensburg',
    'versicherungsnehmer.isVorsteuerAbzugsberechtigt',
    'versicherungsnehmer.hasJahreskarteOeffentlicherPersonenverkehr',
    'versicherungsnehmer.jahreskarteOeffentlicherPersonenverkehr',
    'versicherungsnehmer.hasWohneigentum',
    'versicherungsnehmer.wohneigentum',
    'versicherungsnehmer.mitgliedschaften',
  ],
};

export const pkwInputDehydrationDefinitions: ConditionalRequestDefinition[] = [
  isNoAbweichenderHalter,
  isErstbesitzer,
  isFirma,
  isCompanyOrWorksInAutomotive,
  isNotGermanOrIsCompany,
  isFahrerkreisVNDriver,
  isFahrerkreisFix,
  isFahrerkreisAny,
  isFahrerkreisNoAgeRestriction,
  isNoSaisonkennzeichen,
  isNotAnAdditionalCar,
  isNoVollkasko,
  isNoTeilkasko,
  isHaftpflicht,
  isNoSaisonKennzeichen,
  isNoJahreskarteOffentlicherPersonenverkehr,
  isNoWohnungseigentum,
  isNoMinors,
  isNoVorversicherung,
  hasOneChild,
  hasSeveralChildren,
  hasNoDamage,
  isOnlyHaftpflichtFeature,
  isNotHaftpflichtFeature,
  isOnlyVollkaskoFeature,
  hasGapDeckung,
  isAlsBetriebsausgabeAnerkannt,
  isVnVorsteuerabzugsberechtigt,
  temporaryField,
];
